import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const LocationsPage = ({ authed }) => {
  useEffect(() => {
    document.title = 'Locations'
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <div className='navClearingExtended'></div>
      <div className='container'>
        <div className='row align-contenmt-center'>
          <div className='col-lg-12'>
            <h1>
              <strong>Discover Where You&apos;d Like to Work</strong>
            </h1>
            <p className='lead'>
              No matter where you live in the U.S., the likelihood is, there is
              a Barnes &amp; Noble nearby that would be a great fit for you. You
              love books! We are booklovers! Join a team filled with passionate
              booksellers who are just like you! We also hire for Corporate and
              Distribution Center positions in New York, New Jersey, and Nevada.
            </p>
            <br />
            <br />
          </div>
        </div>
      </div>

      <div className='container'>
        <div className='row '>
          <div className='col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12'>
            <img
              className='img-fluid'
              width='100%'
              title='Barnes and Noble Retail Stores'
              alt='Barnes and Noble Retail Stores'
              src='/img/Locations-Retail-Stores.jpg'
            />
          </div>
          <div className='col-lg-7 col-md-7 col-sm-12'>
            <h5>
              <strong>Retail Stores</strong>
            </h5>
            <p>
              Our Booksellers and Café teams are the frontline of our business.
              The exceptional, personalized service they offer is what connects
              us to our customers. Barnes &amp; Noble hosts nearly 100,000
              events a year. We count on our Booksellers to engage with our
              neighbors, including regional businesses and educational and
              entertainment institutions, tailoring our stores to become pillars
              of the local communities. Their knowledge of popular culture and
              trends as well as the products we sell helps our booksellers stay
              fresh and relevant. If you are customer-service oriented and
              passionate about helping others, join our Barnes &amp; Noble
              Bookseller or Café teams.
            </p>
            <Link
              className='btn btn-outline-dark'
              to={authed ? '/internal/retail-jobs' : '/retail-jobs'}
            >
              View Available Positions
            </Link>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div className='row'>
          <div className='col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12'>
            <img
              title='Barnes and Noble Home Office'
              alt='Barnes and Noble Home Office'
              width='100%'
              data-displaymode='Original'
              className='img-fluid'
              src='/img/Corporate-Headquarters-Locations-Page.jpg'
            />
            <div className='spacer-div'>&nbsp;</div>
          </div>
          <div className='col-lg-7 col-md-7 col-sm-12'>
            <h5>
              <strong>Home Office</strong>
            </h5>
            <p>
              At the heart of Barnes &amp; Noble, our Corporate team brings our
              many stores into alignment under a unified strategic vision. Team
              members work behind the scenes to ensure smooth operations and
              consistent excellence at all customer touchpoints. Opportunities
              may include positions in Accounting, Customer Service,
              Digital/eCommerce, Finance, HR, IT, Marketing, Merchandising,
              Publishing, and Store Operations. If you are interested
              in working with a collaborative innovative team, we’re always
              seeking progressive, dynamic talent.
            </p>
            <Link
              className='btn btn-outline-dark'
              to={authed ? '/internal/home-office-jobs' : '/corporate-jobs'}
            >
              View Available Positions
            </Link>
          </div>
        </div>

        <br />
        <br />
        <br />

        <div className='row'>
          <div className='col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12'>
            <img
              className='img-fluid'
              width='100%'
              title='Barnes and Noble Distribution Centers'
              alt='Barnes and Noble Distribution Centers'
              src='/img/Locations-Distribution-Centers.png'
            />
          </div>
          <div className='col-lg-7 col-md-7 col-sm-12'>
            <h5>
              <strong>Distribution Centers</strong>
            </h5>
            <p>
              It’s a big job to keep all Barnes &amp; Noble retail stores
              throughout the country up to date with the latest books and other
              merchandise. Teams at our Distribution Center stay on top of it
              all with cutting-edge inventory management systems and industrial
              equipment. Areas of opportunity include distribution, logistics,
              and more. If you are interested in working in partnership with an
              efficient, high-energy team, join our Distribution Centers.
            </p>
            <Link
              className='btn btn-outline-dark'
              to={authed ? '/internal/distribution-jobs' : '/distribution-jobs'}
            >
              View Available Positions
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default LocationsPage
